module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/result-search-card/result-search-card.component.css
// module id = ./src/app/home/result-search-card/result-search-card.component.css
// module chunks = main